export enum CommunicationSubjectEnum {
  onFacUpdated = 0,
  onManagerFiltersUpdated
}
